// extracted by mini-css-extract-plugin
module.exports = {"buttons":"AllowanceItemsTable__buttons--3y1ad"};